<template>
  <h1 >RFID Processing Order Selection</h1>
  <div id="page-rfid-dashboard" class="content-section">
    <div class="page-section">

      <div class="row">
          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Go Back"
                  input-class="$reset btn-rfid-xsm btn btn-rfid btn-associate btn-goback"
                  @click="goTo('Dashboard')"
                  prefix-icon="arrowLeft"
                  prefix-icon-class="btn-rfid-back"
              />
            </div>
          </div>
        </div>
        
        <div class="clearfix"></div>

       <div class="content-section">
         
          <div class="row">
            <div class="col-md-4">
              <div class="formkit-inner">
                <input type="text" placeholder="Search" class="formkit-input" @keyup.enter="applyFilter"
                  @input="applyFilter"  v-model="searchValue">
              </div>

            </div>
            <div class="col-md-3">
                <div class="mt-2">
                  <button @click="clearFilter" id="clearFilter">Clear filter</button>
                </div>
            </div>
          </div>

          <div class="clearfix mb-3"></div>

          <easy-data-table
              v-model:server-options="serverOptions"
              :server-items-length="serverItemsLength"
              :headers="headers"
              :items="processingOrders"
              :search-field="searchField"
              :search-value="searchValue"
              :loading="loading"
              alternating
              border-cell
              buttons-pagination
              multi-sort
              server-mode
               :body-row-class-name="getRowClass"
          >

          <template #item-order_id="item" :title="getRowTitle(item)">
            <div :title="getRowTitle(item)">
              <router-link :to="{ name: 'ViewOrderRfid', params: { id: item.order_id } }" >
                <div >{{ item.order_id }}</div>
              </router-link>
            </div>
              
            </template>

            <template #item-customer_name="item">
              <div :title="getRowTitle(item)">
                <router-link target="_blank" :to="{ name: 'ViewCustomer', params: { id: item.customer_id } }">
                  <div >{{ item.customername }}</div>
                </router-link>
             </div>
            </template>
            <template #item-customer_id="item">
              <div :title="getRowTitle(item)"> {{item.customer_id}}</div>
            </template>
            <template #item-time_placed="item">
              <div :title="getRowTitle(item)"> {{formatFullDateEN(item.timeplaced)}}</div>
            </template>
            <template #item-date_collect="item">
              <div :title="getRowTitle(item)"> {{formatDateEN(item.datecollect)}}</div>
            </template>
            <template #item-date_due="item">
              <div :title="getRowTitle(item)"> {{formatDateEN(item.datedue)}}</div>
            </template>
             <template #item-location="item">
              <div :title="getRowTitle(item)"> {{item.locationname}}</div>
            </template>
             <template #item-processing_status="item">
              <div :title="getRowTitle(item)"> {{item.pro_status_type}}</div>
            </template>
            

          </easy-data-table>
        </div>  

      </div>
  </div>
</template>

<script setup>

import {onMounted, ref, inject, reactive, watch} from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css';
import RFIDService from "@/services/RFIDService";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import { formatLondon, formatFullDateEN, formatDateEN } from '@/utils/dateUtils';
import OrderService from '@/services/OrderService';

const processingOrders =  ref([]);
const headers = [
  { text: "Order ID", value: "order_id", sortable: true  },
  { text: "Customer ID", value: "customer_id", sortable: true },
  { text: "Customer Name", value: "customer_name", sortable: true },
 
  { text: "Location", value: "location", sortable: true },
  { text: "Date Placed", value: "time_placed", sortable: true },
  { text: "Collection Date", value: "date_collect", sortable: true },
  { text: "Due Date", value: "date_due", sortable: true },
  { text: "Status", value: "processing_status", sortable: true },
 // { text: "Actions", value: "operations" },
];
const searchField = ref("order_id");
const searchValue = ref("");
const datepickerClearedKey = ref(0);

const forceRenderDatepicker = () => {
  datepickerClearedKey.value += 1;
};

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
  page: 1,
  rowsPerPage: 25,
  sortBy: "date_due",
  sortType: "asc",
  exportFormat: "none",
  search: "",
  rfid_account: 1,
});


//highlight the row if is overdue or express order
const getRowClass = (item) => {
  let itemDate = new Date(item.datedue);
  return item.turnaround === 'express' || itemDate < new Date() ? 'table-error' : '';
};
//check the date and turnaround and return the title for the row
const getRowTitle = (item) => {
  let itemDate = new Date(item.datedue);
  return item.turnaround === 'express' ? 'Express order' : itemDate < new Date() ? 'Overdue order' : '';
};

// Watch for changes in sorting (or rows per page or pagination)
watch(serverOptions, (newOptions, oldOptions) => {
  
   // If sortBy or sortType is null, treat as "no sort"
  if (!newOptions.sortBy || !newOptions.sortType) {
    // Handle the "no sort" case, e.g., reset to default sort or unsorted
    return;
  }

  // Only apply filter if sortBy or sortType changed
  if (
    newOptions.sortBy !== oldOptions.sortBy ||
    newOptions.sortType !== oldOptions.sortType
  ) {
    applyFilter();
  }
}, { deep: true });
watch(() => serverOptions.value.page, () => {
  console.log("Page changed to: ", serverOptions.value.page);
  applyFilter(false);
});
watch(() => serverOptions.value.rowsPerPage, () => {
  console.log("rowsPerPage changed to: ", serverOptions.value.rowsPerPage);
  applyFilter(false);
});

const goTo = (pageSection, item=false) =>   {
  switch (pageSection) {
    case "Dashboard":
      window.open(
          "/rfid/dashboard",
          "_self"
      );
      break;
    
  }
}

const applyFilter = (resetPage) => {
  let updateOptions = serverOptions.value;

  if (typeof updateOptions.rfid_account == "undefined") {
    updateOptions.rfid_account = 1;
  }
  if (typeof searchValue.value != "undefined") {
    updateOptions.search = searchValue.value;
  }
  if (resetPage) {
    updateOptions.page = 1;
  }
  serverOptions.value = updateOptions;
  loadRFIDAccountsOrders();
};

const clearFilter = () => {

  const updateServerOptions = serverOptions.value;
  searchValue.value = "";
  serverOptions.value = updateServerOptions;

  forceRenderDatepicker();
  applyFilter(true);
};


const loadRFIDAccountsOrders = async () => {

  serverOptions.value.status_filter = '1,2';
  //console.log(serverOptions.value);
  loading.value = true;
  const {
    serverCurrentPageItems,
    serverTotalItemsLength,
  } = await OrderService.searchRFIDAccountsOrders(serverOptions.value);
  processingOrders.value = serverCurrentPageItems;
  serverItemsLength.value = serverTotalItemsLength;
  console.log('serverItemsLength', serverItemsLength.value);
  console.log('processingOrders', processingOrders.value);
  loading.value = false;
}
onMounted(async () => {
  loadRFIDAccountsOrders();

});

</script>

<style>
.table-error td {
  background-color: #f8d7da !important;
}
</style>
<style scoped>
.main-section > h1:first-child {
  background: var(--process-bg-color);
}
.error-message {
  color: var(--red-color);
  font-weight: bold;
}

</style>
